
import { defineComponent, PropType, ref } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  VulnerabilityInfoService
} from '@/views/dashboard/group/client/terminal-info/vulnerability-info/vulnerability-info.service'
import LeakView from '@/views/dashboard/safe-status/vulnerability-fix/_components/leak-view-table/leak-view-table.vue'
import { ClientItem } from '@/views/dashboard/_type/client-item'

export default defineComponent({
  components: { LeakView },
  props: {
    terminalInfo: {
      type: Object as PropType<ClientItem>,
      default: () => ({})
    },
  },

  setup (props, context) {
    const injector = useReflectiveInjector([VulnerabilityInfoService])
    const service = injector.get(VulnerabilityInfoService)

    const isLoading = ref(false)

    function handleAuthSuccess () {
      context.emit('authSuccess')
    }

    return {
      isLoading,
      handleAuthSuccess,
    }
  }
})
